export * from "../../base/store/mutations";

export function set_options(state, payload) {
	state.options = payload;
}
